"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Label = exports.Icon = exports.HiddenInput = exports.FileWrapper = exports.FileButton = exports.ErrorMessage = exports.DocumentWrapper = exports.DocumentList = exports.Document = exports.Delete = exports.ButtonContent = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _Button = _interopRequireDefault(require("../Button"));
var _react = require("@emotion/react");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs11"
} : {
  target: "e1qtr0rs11",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1iq60ec",
  styles: "display:grid;grid-row-gap:0.5em"
} : {
  name: "1iq60ec",
  styles: "display:grid;grid-row-gap:0.5em",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const FileWrapper = exports.FileWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs10"
} : {
  target: "e1qtr0rs10",
  label: "FileWrapper"
})();
const DocumentList = exports.DocumentList = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs9"
} : {
  target: "e1qtr0rs9",
  label: "DocumentList"
})(process.env.NODE_ENV === "production" ? {
  name: "8v4mug",
  styles: "display:grid;grid-row-gap:4px;margin-bottom:10px"
} : {
  name: "8v4mug",
  styles: "display:grid;grid-row-gap:4px;margin-bottom:10px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const DocumentWrapper = exports.DocumentWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs8"
} : {
  target: "e1qtr0rs8",
  label: "DocumentWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1wq95ig",
  styles: "display:grid;grid-template-columns:1fr 65px;height:32px"
} : {
  name: "1wq95ig",
  styles: "display:grid;grid-template-columns:1fr 65px;height:32px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const Document = exports.Document = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs7"
} : {
  target: "e1qtr0rs7",
  label: "Document"
})(props => /*#__PURE__*/(0, _react.css)("background-color:", props.theme.illustrationPrimary20, ";display:flex;align-items:center;padding:0 1em;overflow:hidden;&>span{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" + (process.env.NODE_ENV === "production" ? "" : ";label:Document;")));
const Delete = exports.Delete = /*#__PURE__*/(0, _base.default)(_Button.default, process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs6"
} : {
  target: "e1qtr0rs6",
  label: "Delete"
})(process.env.NODE_ENV === "production" ? {
  name: "ge3ylf",
  styles: "&>span{display:flex;align-self:center;justify-content:flex-end;place-items:center;}"
} : {
  name: "ge3ylf",
  styles: "&>span{display:flex;align-self:center;justify-content:flex-end;place-items:center;}",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _ref2 = process.env.NODE_ENV === "production" ? {
  name: "f7ay7b",
  styles: "justify-content:center"
} : {
  name: "o59g6y-FileButton",
  styles: "justify-content:center;label:FileButton;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const FileButton = exports.FileButton = /*#__PURE__*/(0, _base.default)("button", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs5"
} : {
  target: "e1qtr0rs5",
  label: "FileButton"
})(props => /*#__PURE__*/(0, _react.css)("display:flex;align-items:center;height:38px;width:", props.nostyle ? '38px' : props.width, ";border:", props.nostyle ? 'none' : '1px dashed #cccccc', ";border-radius:19px;padding:0;cursor:pointer;font-size:0.9em;background-color:transparent;outline:0;&:focus{border-color:black;}", props.nostyle && _ref2, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:FileButton;")));
const ButtonContent = exports.ButtonContent = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs4"
} : {
  target: "e1qtr0rs4",
  label: "ButtonContent"
})(process.env.NODE_ENV === "production" ? {
  name: "1vre5nf",
  styles: "display:grid;grid-template-columns:1fr 24px;padding:0 0.5em 0 1em;width:100%;align-items:center;text-align:left"
} : {
  name: "1vre5nf",
  styles: "display:grid;grid-template-columns:1fr 24px;padding:0 0.5em 0 1em;width:100%;align-items:center;text-align:left",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const HiddenInput = exports.HiddenInput = /*#__PURE__*/(0, _base.default)("input", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs3"
} : {
  target: "e1qtr0rs3",
  label: "HiddenInput"
})(process.env.NODE_ENV === "production" ? {
  name: "eivff4",
  styles: "display:none"
} : {
  name: "eivff4",
  styles: "display:none",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var _ref = process.env.NODE_ENV === "production" ? {
  name: "8rqqoj",
  styles: "transform:rotate(-60deg)"
} : {
  name: "xkxrin-Icon",
  styles: "transform:rotate(-60deg);label:Icon;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
const Icon = exports.Icon = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs2"
} : {
  target: "e1qtr0rs2",
  label: "Icon"
})(({
  rotated
}) => /*#__PURE__*/(0, _react.css)(rotated && _ref, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:Icon;")));
const Label = exports.Label = /*#__PURE__*/(0, _base.default)("span", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs1"
} : {
  target: "e1qtr0rs1",
  label: "Label"
})(process.env.NODE_ENV === "production" ? {
  name: "1ge8ozm",
  styles: "line-height:22px;font-size:1em;font-weight:600;margin-bottom:4px"
} : {
  name: "1ge8ozm",
  styles: "line-height:22px;font-size:1em;font-weight:600;margin-bottom:4px",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const ErrorMessage = exports.ErrorMessage = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1qtr0rs0"
} : {
  target: "e1qtr0rs0",
  label: "ErrorMessage"
})("font-size:14px;padding-left:10px;font-weight:600;margin-bottom:0;color:", props => props.theme.alert, ";");